import React, { FC } from 'react';
import AdminTabs from 'Components/Admin/AdminTabs';
import { RouteComponentProps } from 'react-router-dom';
import AlertBox from 'Components/Common/AlertBox';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    height: '100%',
  },
}));

const AdminLayout: FC<RouteComponentProps & { children: React.ReactNode }> = (
  { children, location },
) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AdminTabs location={location}>
        {children}
      </AdminTabs>
      <AlertBox />
    </div>
  );
};

export default AdminLayout;
